import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
//import Treeviewpage from "./Treeviewpage";
//import TreeviewOrg from './TreeviewOrg';
import { useDispatch, useSelector } from "react-redux";
import Tree_Alarm from "../../Tempdata/Tree_Alarm";
import {updatealarmtreepathselected} from '../../store/mainpage_data';
import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { Link } from 'react-router-dom';
import { Tooltip } from "@mui/material";
import { Checkbox } from '@mui/material';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import Button from '@mui/material/Button';
import LK_Filter from '../../images/LK_Filter';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            style={{borderRadius:"0px"}}
        >
            {value === index && (
                <Box sx={{ p: 0, borderRadius:"0px" }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


export default function AlarmLeftPane(props) {
    const dispatch = useDispatch()
    const theme = useSelector((state) => state.themedata.theme)
    const[treeselected, setTreeselected] = useState(Tree_Alarm)
    const [selecteditemid, setSelecteditemid] = useState('1')
    const overviewstate = useSelector((state) => state.mainpagedata.overviewbarstate)
    const [value, setValue] = React.useState(0);
    const [pagesize, setPagesize] = useState(270)

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    var path = [];
    //const height = props.expanded ? 900 : 798;
     useEffect(() => {
        if (overviewstate) {
          setPagesize(295);
        } else {
          setPagesize(260);
        }
      }, [overviewstate]);

    const handleitemselected = (event, ids) => {
        path = []
        setSelecteditemid(ids)
        generateselectedelementpath(ids, [treeselected])
        dispatch(updatealarmtreepathselected(path.reverse()))
    }
    const generateselectedelementpath = (key, tree) => {
        for(let i=0; i<tree.length; i++) {
            const node = tree[i];
            if(node.children.length !== 0) {
                if(node.id === key) {
                    path.push(node.label)
                    //parentkey = node.key
                    return
                } else {
                    generateselectedelementpath(key, node.children)
                    if(path.length !== 0) {
                        path.push(node.label)
                        return
                    }
                }
            } else {
                if(node.id === key) {
                    path.push(node.label)
                    //return
                }
            }
        }
    }
    const[checkedstate, setCheckedState] = useState({
        checkedtag:false,
        checkeddevice:false,
        checkedgroup:false,
        checkedunack:false,
        checkedactive:false
    });

  
    function handleTagFilterCheck(event, argumentvalue){
        
        // Create new state with all filters set to false
        const newState = {
            checkedtag: false,
            checkeddevice: false,
            checkedgroup: false,
            checkedunack: false,
            checkedactive: false
        };
        
        // Only set the selected filter to true (toggle it)
        // If it was already checked, it will remain false (unchecked)
        // If it was unchecked, it will become true (checked)
        const isCurrentlyChecked = checkedstate[`checked${argumentvalue}`];
        if (!isCurrentlyChecked) {
            newState[`checked${argumentvalue}`] = true;
        }
        
        setCheckedState(newState);
        props.setCheckfilterlist(newState);
    }

    return (
        <Box sx={{/*width:`calc(100vw - ${1702}px)`*/ width: "11.5%", border: "1px solid var(--HighlightedText_Stroke)",backgroundColor: 'var(--SecondaryBackground)', borderRadius: '0px 0px 0px 0px',boxSizing: 'border-box'}}>
            <Box sx={{ backgroundColor: 'var(--PrimaryBackground)' }}>
            </Box>
            <Box  sx={{width: '100%',height:"100%"}} style={{overflow:"auto"}}>
                <CustomTabPanel value={value} index={0} style={{overflow:"auto"}}>
                        {/* <Box sx={{ height: '100%', textAlign: 'left', margin: '10px', overflow:'auto' }}>
                            <Tooltip>
                                <RichTreeView
                                    sx={{
                                        '& MuiTreeItem-group': {
                                            color: 'var(--action-button-light) !important',
                                            fontWeight: '700 !important'
                                        },
                                        '& .Mui-selected:hover': {
                                            backgroundColor: 'transparent !important',
                                        },
                                        '& .Mui-selected': {
                                            backgroundColor: 'transparent !important',
                                            color: '#008CD7 !important',
                                            fontWeight: '900 !important'
                                        },
                                        '& .MuiTreeItem.Mui-focused': {
                                            backgroundColor: 'transparent !important',
                                            color: 'var(--action-button-light) !important',
                                            fontWeight: '700 !important'
                                        },
                                        // '& .Mui-selected .MuiTreeItem-content': {
                                        //     backgroundColor: 'transparent !important',
                                        //     color: '#008CD7 !important',
                                        //     fontWeight: '700 !important'
                                        // },
                                        '& .MuiTreeItem-label':{
                                            fontSize:'16px',
                                            fontWeight:400,
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden'
                                        },
                                        color: 'var(--PrimaryText)',
                                        fontSize:'50px',
                                    }} 
                                    items={[treeselected]}
                                    onSelectedItemsChange={handleitemselected}
                                    defaultSelectedItems={'1'}
                                    aria-label="customized"
                                    selectedItems={selecteditemid}
                                    //defaultExpandedItems={['pickers']}
                                    //slots={{ item: CustomTreeItem }}
                                />
                            </Tooltip>
                        </Box>        */}               
                        <Box>

                            <div style={{display:"flex", flexDirection:"row"}}>
                                <div style={{marginLeft:"15px",marginTop:"7px"}}><LK_Filter color={"#005C8E"} width={"17px"} height={"17px"} /></div>
                                <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",marginTop:"6px", textAlign:"left"}}>Select Filters</Typography>
                            </div>
                            <div style={{display:"flex", flexDirection:"row",alignItems:'center',marginTop:"7px"}}>
                                <div>
                                    <Checkbox checkedIcon={<CheckBoxOutlinedIcon />} style={{color:"008CD7", paddingBottom:"0px",paddingTop:"0px"}}
                                        checked={checkedstate.checkedtag}
                                        sx={{
                                            color: 'var(--HighlightedText_Stroke)',
                                            '& .MuiSvgIcon-root': {
                                                fontSize: '20px',
                                                color: 'var(--HighlightedText_Stroke)'
                                            }
                                          }}
                                        onChange={(event) => handleTagFilterCheck(event,'tag')}
                                    />
                                </div>
                               <div style={{paddingTop:"3px"}}>
                                    <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px", textAlign:"left"}}>Apply Tag Filter</Typography>
                               </div>
                            </div>
                            <div style={{display:"flex", flexDirection:"row",alignItems:'center',marginTop:"7px"}}>
                                <div>
                                    <Checkbox checkedIcon={<CheckBoxOutlinedIcon />} style={{color:"008CD7", paddingBottom:"0px",paddingTop:"0px"}}
                                        checked={checkedstate.checkeddevice}
                                        sx={{
                                            color: 'var(--HighlightedText_Stroke)',
                                            '& .MuiSvgIcon-root': {
                                                fontSize: '20px',
                                                color: 'var(--HighlightedText_Stroke)'
                                            }
                                          }}
                                        onChange={(event) => handleTagFilterCheck(event,'device')}
                                    />
                                </div>
                               <div style={{paddingTop:"3px"}}>
                                    <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px", textAlign:"left"}}>Apply Device Filter</Typography>
                               </div>
                            </div>
                            <div style={{display:"flex", flexDirection:"row",alignItems:'center',marginTop:"7px"}}>
                                <div>
                                    <Checkbox checkedIcon={<CheckBoxOutlinedIcon />} style={{color:"008CD7", paddingBottom:"0px",paddingTop:"0px"}}
                                        checked={checkedstate.checkedgroup}
                                        sx={{
                                            color: 'var(--HighlightedText_Stroke)',
                                            '& .MuiSvgIcon-root': {
                                                fontSize: '20px',
                                                color: 'var(--HighlightedText_Stroke)'
                                            }
                                          }}
                                        onChange={(event) => handleTagFilterCheck(event, 'group')}
                                    />
                                </div>
                               <div style={{paddingTop:"3px"}}>
                                    <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px", textAlign:"left"}}>Apply Group Filter</Typography>
                               </div>
                               
                            </div>
                            <div style={{display:"flex", flexDirection:"row",alignItems:'center',marginTop:"7px"}}>
                                <div>
                                    <Checkbox checkedIcon={<CheckBoxOutlinedIcon />} style={{color:"008CD7", paddingBottom:"0px",paddingTop:"0px"}}
                                        checked={checkedstate.checkedunack}
                                        sx={{
                                            color: 'var(--HighlightedText_Stroke)',
                                            '& .MuiSvgIcon-root': {
                                                fontSize: '20px',
                                                color: 'var(--HighlightedText_Stroke)'
                                            }
                                          }}
                                        onChange={(event) => handleTagFilterCheck(event, 'unack')}
                                    />
                                </div>
                               <div style={{paddingTop:"3px"}}>
                                    <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px", textAlign:"left"}}>Show UnAck Alerts</Typography>
                               </div>
                               
                            </div>
                            <div style={{display:"flex", flexDirection:"row",alignItems:'center',marginTop:"7px"}}>
                                <div>
                                    <Checkbox checkedIcon={<CheckBoxOutlinedIcon />} style={{color:"008CD7", paddingBottom:"0px",paddingTop:"0px"}}
                                        checked={checkedstate.checkedactive}
                                        sx={{
                                            color: 'var(--HighlightedText_Stroke)',
                                            '& .MuiSvgIcon-root': {
                                                fontSize: '20px',
                                                color: 'var(--HighlightedText_Stroke)'
                                            }
                                          }}
                                        onChange={(event) => handleTagFilterCheck(event, 'active')}
                                    />
                                </div>
                               <div style={{paddingTop:"3px"}}>
                                    <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px", textAlign:"left"}}>Show Active Alerts</Typography>
                               </div>
                               
                            </div>
                        </Box>
                        
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>

                </CustomTabPanel>
           
            </Box>
        </Box>
    );
}



 